import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';


const DonutChart = (props) => {
  const { title, value, data, color, valueColor = '#4CAF50' } = props;
  
  const chartData = Array.isArray(data) ? data : [];
  const COLORS = Array.isArray(color) ? color : ['#8884d8'];
  
  return (
    <div style={{ position: 'relative', width: 300, height: 300 }}>
       <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            innerRadius={65}
            strokeWidth={0}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}            
          </Pie>          
        </PieChart>
      </ResponsiveContainer>
      <div style={{ 
        position: 'absolute', 
        top: '50%', 
        left: '50%', 
        transform: 'translate(-50%, -50%)', 
        textAlign: 'center',
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '120px'
      }}>
        <span style={{ fontSize: '1.2rem', fontWeight: 700, color: valueColor, lineHeight: 1 }}>{value}</span>
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#666', lineHeight: 1.1, marginTop: '4px', textAlign: 'center', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{title}</span>
      </div>
    </div>
  );
};
export default DonutChart;
